/**
 * Route paths for the VER-128 design-preview surfaces.
 *
 * Nothing in the app navigates here — these screens are opened by typing the URL. That is the
 * point: they are mock-only, and while they were wired into the "Create programme" nav entry and
 * the My Programmes "Add New" button, staging had no route to the real wizard and no programme
 * could be created there at all.
 *
 * So if a link to one of these paths is ever added, it must be gated on `isDesignPreviewEnabled()`
 * — the routes are only mounted under that flag, and a link to an unmounted path renders a blank
 * page rather than erroring — AND it must not be the only way to reach the shipped screen it sits
 * in front of.
 */

/** The Create Programme stepper refresh (VER-128 step 1–4 plus the ready step). */
export const CREATE_PROGRAMME_PREVIEW_PATH = "/preview/create-programme";

/** The collection-overview refresh. `:collectionId` is mock — any value renders MOCK_COLLECTION. */
export const collectionPreviewPath = (collectionId: string | number): string => `/preview/collection/${collectionId}`;
